import React, { useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField,
  Grid, Typography, InputAdornment, Alert
} from '@mui/material';
import { brand } from '../../theme/colors';

const fmt = (n) => parseFloat(n || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export default function BOQLaborPaymentDialog({ open, onClose, category, onSubmit, loading }) {
  const [form, setForm] = useState({
    amount: '',
    payment_date: new Date().toISOString().split('T')[0],
    notes: '',
    proof_url: ''
  });

  const laborCost = parseFloat(category?.labor_cost || 0);
  const paidToDate = parseFloat(category?.labor_paid_to_date || 0);
  const balance = laborCost - paidToDate;
  const amount = parseFloat(form.amount) || 0;
  const newBalance = balance - amount;

  const handleChange = (field) => (e) => {
    setForm(prev => ({ ...prev, [field]: e.target.value }));
  };

  const handleSubmit = () => {
    onSubmit({
      ...form,
      amount
    });
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: 3 } }}>
      <DialogTitle sx={{ background: brand.gradient, color: '#fff', pb: 1.5 }}>
        <Typography variant="h6" sx={{ fontWeight: 700 }}>Log Labour Payment</Typography>
        <Typography variant="body2" sx={{ opacity: 0.85, mt: 0.5 }}>
          {category?.name} · ${fmt(balance)} owing
        </Typography>
      </DialogTitle>

      <DialogContent sx={{ pt: 3, mt: 1 }}>
        <Grid container spacing={2.5}>
          <Grid item xs={6}>
            <TextField
              label="Amount Paid"
              type="number"
              value={form.amount}
              onChange={handleChange('amount')}
              fullWidth
              required
              InputProps={{ startAdornment: <InputAdornment position="start">$</InputAdornment> }}
              helperText={`Paid to date: $${fmt(paidToDate)}`}
              inputProps={{ min: 0, step: 0.01 }}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Payment Date"
              type="date"
              value={form.payment_date}
              onChange={handleChange('payment_date')}
              fullWidth
              InputLabelProps={{ shrink: true }}
            />
          </Grid>

          {amount > 0 && (
            <Grid item xs={12}>
              <Alert severity={newBalance < 0 ? 'warning' : newBalance === 0 ? 'success' : 'info'} variant="outlined" sx={{ py: 0.5 }}>
                After this payment: ${fmt(Math.max(newBalance, 0))} owing{newBalance < 0 ? `, $${fmt(Math.abs(newBalance))} overpaid` : ''}
              </Alert>
            </Grid>
          )}

          <Grid item xs={12}>
            <TextField
              label="Proof / Receipt URL"
              value={form.proof_url}
              onChange={handleChange('proof_url')}
              fullWidth
              placeholder="Optional"
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Notes"
              value={form.notes}
              onChange={handleChange('notes')}
              fullWidth
              multiline
              rows={2}
              placeholder="Stage, agreement note, reference number..."
            />
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2.5 }}>
        <Button onClick={onClose} sx={{ color: 'text.secondary' }}>Cancel</Button>
        <Button
          variant="contained"
          onClick={handleSubmit}
          disabled={amount <= 0 || loading}
          sx={{ bgcolor: brand.primary, '&:hover': { bgcolor: brand.primaryDark }, borderRadius: 2, px: 3 }}
        >
          {loading ? 'Logging...' : 'Log Payment'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
